
<span class="loader" 
[style.--width1]=" width + 'px'"
[style.--loaderThickness]=" thickness + 'px'"
[style.--primaryColor]="primaryColor"
[style.--secondaryColor]="secondaryColor"></span>